module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/weddingdress-3315a5282660847ad03232e432affced.webp";